import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { useDropzone } from "react-dropzone";
import foo_logo from "../../assets/foo_mascot_chef_hat@2x.svg";
import { PARTNER_LOGO_UPLOAD, GET_PARTNER } from "./queries";

const getLogoUrl = (logo: string | null): string => {
  if (!logo) return foo_logo;
  if (logo.startsWith("http")) return logo;
  return `https://cdn.foopos.mx${logo.replace("/img", "").slice(0)}`;
};

const General: React.FC = () => {
  const user = JSON.parse(localStorage.getItem("user") || "");
  const [logoUrl, setLogoUrl] = useState<string>(
    getLogoUrl(user?.partner?.logo)
  );

  const [uploadLogo, { loading }] = useMutation(PARTNER_LOGO_UPLOAD, {
    refetchQueries: [{ query: GET_PARTNER }],
    onCompleted: (data) => {
      const newLogo = data.partnerLogoUpload.logo;
      setLogoUrl(getLogoUrl(newLogo));
      const updatedUser = { ...user, partner: { ...user.partner, logo: newLogo } };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    },
  });

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        uploadLogo({ variables: { file: acceptedFiles[0] } });
      }
    },
    [uploadLogo]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: 5 * 1024 * 1024,
    accept: "image/png,image/jpeg",
    disabled: loading,
    onDropRejected: (rejectedFiles) => {
      const error = rejectedFiles[0]?.errors[0];
      if (error?.code === "file-too-large") {
        alert("El archivo es demasiado grande. El tamaño máximo es 5MB.");
      } else if (error?.code === "file-invalid-type") {
        alert("Solo se permiten archivos PNG y JPG.");
      }
    },
  });

  return (
    <div className="row justify-content-center mt-3">
      <div className="col">
        <div className="card sticky-top">
          <div style={{ height: 100, backgroundColor: "#3e72af" }} />
          <div className="card-body text-center">
            <div {...getRootProps()} style={{ cursor: "pointer" }}>
              <input {...getInputProps()} />
              <button type="button" className="btn btn-transparent user_avatar">
                {loading ? (
                  <div style={{ padding: "20px" }}>
                    <i className="fas fa-spinner fa-spin fa-2x"></i>
                    <p className="mt-2 mb-0 text-muted">Subiendo...</p>
                  </div>
                ) : (
                  <img
                    src={logoUrl}
                    className=""
                    style={{ maxWidth: "60%" }}
                    alt="companylogo"
                  />
                )}
              </button>
              <small className="text-muted d-block mb-2">
                Click para cambiar logo
              </small>
            </div>
            <p>
              {user.partner.company_name}
              <br />
              {user.email} <br />
              {user.name} <br />
              <br />
              {`v.${process.env.REACT_APP_CURRENT_GIT_SHA}`}
            </p>
            <button
              type="button"
              className="btn btn-link text-danger btn-sm mt-4"
            >
              Cambiar Password
            </button>
          </div>
        </div>
      </div>
      <Link className="btn btn-block btn-danger mt-4" to="/logout">
        Cerrar sesión
      </Link>
      <button
        className="btn btn-block btn-outline-secondary mt-4"
        onClick={() => {
          window.location.reload();
        }}
      >
        Actuzalizar Versión
      </button>
    </div>
  );
};

export default General;
